document.addEventListener('DOMContentLoaded', () => {
  const hint = document.querySelector('.backend-lang-hint')
  if (!hint) return

  const closeBtn = hint.querySelector('.backend-lang-hint__close')
  if (closeBtn) {
    closeBtn.addEventListener('click', () => hint.classList.add('is-hidden'))
  }
})
